module.exports = __webpack_public_path__ + "static/media/add-meal-icon.306e0375.svg";